import React, { useEffect, useState } from "react";
import { IconBtn } from "../../../atom/IconBtn/IconBtn";
import { ChevronLeftArrow } from "../../../constants/icons";
import {
  DEFAULT_COUNTRY_CODE,
  FORGOT_PASSWORD_LANDING_PAGE,
  FORGOT_PASSWORD_RESET_PAGE,
  RESEND_OTP_TIMING,
  OTP_SEND_LIMIT
} from "../../../constants/variables";
import { useAuth } from "../../../context/AuthContext";
import { extractResource } from "../../../helper/extractResource";
import { Button } from "../../UI/Button";

function ForgotPasswordOTPPage(props) {
  const [timer, setTimer] = useState<number>(RESEND_OTP_TIMING);
  const [OTPError, setOTPError] = useState<any>(props.OTPError);
  const [OTPLimit, setOTPLimit] = useState<number>(OTP_SEND_LIMIT);
  const { resourceData } = props;
  const { forgetPassword } = useAuth();

  // ? Handle OTP's value on input change
  const handleChange = (e: { target: { value: React.SetStateAction<string> } }) => {
    props.setOtp(e.target.value);
    setOTPError(false);
  };

  /** creates a recurring function which updates the timer every one second
   *  until timer is reduced to 0
   * */
  const runTimer = () => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);
  };

  /** calls the runTimer function after the page is loaded
   * so as to ensure the timer begins only after the page is fully loaded
   *  */
  useEffect(() => {
    runTimer();
  }, []);

  const handleSubmit = () => {
    if (props.otp != "") props.handleState(FORGOT_PASSWORD_RESET_PAGE); // dummy otp validation
    else setOTPError(true);
  };

  const resendOtp = () => {
    forgetPassword(props.emailOrMobile);
    setTimer(RESEND_OTP_TIMING);
    runTimer();
    setOTPLimit(pre=> pre - 1);
  };

  // ? returns forgot password module's OTP screen
  return (
    <div className="w-full sm:w-80 m-auto h-full flex flex-col justify-between">
      <div className="w-full h-full">
        <div className="flex items-center">
          <IconBtn
            onClick={() => {
              props.handleState(FORGOT_PASSWORD_LANDING_PAGE);
            }}
          >
            <ChevronLeftArrow />
          </IconBtn>
          <p className="font-semibold text-lg mx-3">{extractResource(resourceData, "enterOtp")}</p>
        </div>

        <p className="font-semibold text-base mt-6">
          {`${extractResource(resourceData, "enterOtpSentTo")} ${isNaN(props.emailOrMobile) ? "" : DEFAULT_COUNTRY_CODE} ${
            props.emailOrMobile
          }`}
        </p>

        <div className="space-y-4">
          <div>
            <input
              type="number"
              placeholder={extractResource(resourceData, "enterOtp")}
              className={`pl-5 ${
                OTPError ? "mt-6" : "mt-6 mb-5"
              } rounded-lg rounded-tr-none border border-gray-500 w-full h-12 otp tw-input`}
              value={props.otp}
              name="otp"
              onChange={handleChange}
            />
            <p className="text-typography-error mx-1 my-1 text-xs">
              {OTPError ? extractResource(resourceData, "invalidOtp") : ""}
            </p>
          </div>

          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={() => {
              handleSubmit();
            }}
          >
            {extractResource(resourceData, "confirmAndSignIn")}
          </Button>

          <div className="flex ">
            {timer > 0 ? (
              <div className="m-auto font-semibold w-fit text-center flex my-8">
                <span className="text-typography-secondary mr-1">{extractResource(resourceData, "resendOtp")}</span>
                <span>in {timer}s</span>
              </div>
            ) : (
              <Button color="secondary" variant="text" fullWidth disabled={OTPLimit === 0} onClick={() => resendOtp()}>
                {extractResource(resourceData, "resendOtp")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordOTPPage;
